module.exports = __webpack_public_path__ + "files/6fd1f924cd0bea5d5f74a1365e12184d.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-regular.woff2
// module id = 1579
// module chunks = 60